const WsChevronLeftIcon = ({
  title = "chevronLeftIconTitle",
  className = "",
  onClick
}: {
  title?: string;
  className?: string;
  onClick?: () => void;
}) => {
  return <svg strokeWidth='0' viewBox='0 0 16 16' height='20px' width='20px' focusable={false} stroke='currentColor' fill='currentColor' className={`${className} rotate-180`} onClick={onClick} role='img' aria-labelledby={title} data-sentry-element="svg" data-sentry-component="WsChevronLeftIcon" data-sentry-source-file="ChevronLeftIcon.tsx">
      <title id={title}>Chevron Left Icon</title>
      <path fillRule='evenodd' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z' data-sentry-element="path" data-sentry-source-file="ChevronLeftIcon.tsx"></path>
    </svg>;
};
export default WsChevronLeftIcon;